<template>
  <v-main class="page-suitcase page-suitcase-badge">
    <AppBar/>
    <v-container>

      <div class="badge-list">
        <div class="badge-list-item" v-for="(item, index) in badgeArr" :key="index" @click="openSheet(item)">
          <Badge :info="item" />
        </div>
      </div>

      <BadgeSheet :sheet="sheet" :item="badgeItem" @sheetClose="sheet = false"/>
    </v-container>
  </v-main>
</template>
<script>
import store from '@/store'
import {mixinAuth} from '@/mixins'
import Badge from '@/components/icons/Badge'
import BadgeSheet from "@/components/layout/bottomSheet/BadgeSheet"

export default {
  components: {
    Badge,
    BadgeSheet,
  },
  mixins: [mixinAuth],
  data: () => ({
    sheet: false,
    badgeArr: [],
    badgeItem: {},
    emptyBadgeImg: 'badge/ic_no_badge.svg'
  }),
  created() {
    this.getMemberRewardBadge();
  },
  mounted() {
  },
  methods: {
    openSheet(item) {
      this.badgeItem = item;
      this.sheet = true;
    },
    async getMemberRewardBadge() { // 내 뱃지
      await store.dispatch('getMemberBadge', this.$_payload({'userKey': this.userKey}))
          .then(res => {
            if (res.success) {
              this.badgeArr = res.data;
            } else {
              console.log(res.msg);
              this.badgeArr = [];
            }
          })
          .catch(error => {
            console.error(error);
            this.badgeArr = [];
          })
          .finally(() => {
          })
    }
  }
}
</script>

